import React from 'react'
import clsx from 'clsx'

// Cube
import { classToFComponent, type FCClassContext } from 'cube-react'

// Gov-br
import { BrSelect, type BrSelectProps } from '@govbr-ds/react-components'

import { DominioSelectScope, DominioOption } from '../analise-bulas.scope'

export type DominioSelectProps = {
    className?: string
    label: string
    placeholder: string,
    scope: DominioSelectScope
}

class DominioSelectViewClass implements FCClassContext<DominioSelectProps> {
    scope!: DominioSelectScope

    // :: Listener adapters

    onChangeOptions: BrSelectProps['onChangeOptions'] = (selectedOptions) => {
        this.scope.onChangeOptions(selectedOptions as DominioOption[])
    }

    render({ scope, className, label, placeholder }: DominioSelectProps) {
        this.scope = scope

        return (
            <BrSelect
                className={clsx(className)}
                type="multiple"
                searchDebounceTimeout={0}
                label={label}
                value={scope.value}
                placeholder={placeholder}
                options={scope.options}
                externalFiltering={true}
                isLoading={scope.loading}
                selectAllText={''}
                onChangeOptions={this.onChangeOptions}
                onSearchChange={scope.onSearchChange}
            />
        )
    }
}

export default classToFComponent(DominioSelectViewClass)
